import { APIURL } from "./config";

export const getAllAssessments = async (token: string) => {
  const res = await fetch(`${APIURL}/AssessmentQuestionnaires`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const json = res.json();
  return json;
};

export const postAssessment = async (assessment: any, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentQuestionnaires`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(assessment),
  });
  const json = await res.json();
  return json;
};

export const deleteAssessment = async (id: string | undefined, token: string) => {
  await fetch(`${APIURL}/AssessmentQuestionnaires/${id}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return;
};

export const getAssessmentDetailById = async (id: string, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentQuestionnaires/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const json = await res.json();
  return json;
};

export const updateAssessmentDetailsById = async (assessmentDetails: any, token: string) => {
  await fetch(`${APIURL}/AssessmentQuestionnaires`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(assessmentDetails),
  });
  return;
};

export const getAssessmentsByFilters = async (
  difficulty: any,
  token: string,
  templateIds?: string[],
  selectedSkills?: string[],
  currentPage?: number,
  searchQuery = ""
) => {
  const { min, max } = difficulty;

  let url = `${APIURL}/AssessmentQuestionnaires/filtered`;

  if (currentPage) {
    url += `?pageNumber=${currentPage}&searchQuery=${searchQuery}`;
  } else if (searchQuery) {
    url += `?searchQuery=${searchQuery}`;
  }

  const requestBody = {
    templateIds: templateIds,
    skillIds: selectedSkills,
    minDifficulty: min,
    maxDifficulty: max,
  };


  const res = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(requestBody),
  });
  const json = await res.json();
  return json;
};

export const GetAssessmentForRole = async (roleId: string, candidateId: string, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentQuestionnaires/role/${roleId}?candidateId=${candidateId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await res.json();
  return result;
};

export const updateScoresForRole = async (roleId: string, token: string) => {
  const url = `${APIURL}/AssessmentQuestionnaires/GradeCandidates/${roleId}`;
  try {
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (err) {
    console.error("Error updating metrics:", err);
  }
};

export const postAudioQuestion = async (
  questionId: string,
  questionData: string,
  token: string
) => {
  const res = await fetch(`${APIURL}/AudioQuestions`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ questionId, questionData }),
  });
  const json = await res.json();
  return json;
};

export const deleteAudioQuestion = async (questionId: string, token: string) => {
  await fetch(`${APIURL}/AudioQuestions/${questionId}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const toggleIsInterviewById = async (id: string, token: string) => {
  const res = await fetch(`${APIURL}/AssessmentQuestionnaires/toggle-interview/${id}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res.ok;
};

export const getAllInterviewAssessments = async (token: string) => {
  try {
    const res = await fetch(`${APIURL}/AssessmentQuestionnaires/interview-assessment`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      console.error(`Error fetching interview assessments: ${res.status} ${res.statusText}`);
      return [];
    }
    const json = await res.json();
    return Array.isArray(json) ? json : [];
  } catch (error) {
    console.error("Error fetching interview assessments:", error);
    return [];
  }
};

export const createInterviewSession = async (
  assessmentId: string,
  candidateId: string,
  roleId: string,
  token: string
) => {
  const res = await fetch(`${APIURL}/CandidateInterviewSlot/create`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      assessmentQuestionnaireId: assessmentId,
      candidateId,
      roleId,
    }),
  });
  const json = await res.json();
  return json;
};

export const getAssessMentQuestionnairesByRoleAndCandidate = async (
  candidateId: string,
  roleId: string | undefined,
  slotId: string | undefined,
  token: string
) => {
  const res = await fetch(
    `${APIURL}/AssessmentQuestionnaires/candidate/${candidateId}/role/${roleId}/slot/${slotId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const json = await res.json();
  return json;
};

export const getAssessmentMappingId = async (roleId: string, templateId: string): Promise<string> => {
  const res = await fetch(`${APIURL}/Roles/${roleId}/assessmentMapping/${templateId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch assessment mapping ID");
  }
  const data = await res.json();
  return data.id || "";
};

export const getAssessmentSubmissionVersion = async (roleAssessmentMappingId: string): Promise<number> => {
  const res = await fetch(`${APIURL}/Roles/assessmentVersion/${roleAssessmentMappingId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch assessment submission version");
  }
  const data = await res.json();
  return data.submissionVersion || 1;
};

export const updateAssessmentSubmissionVersion = async (
  roleAssessmentMappingId: string,
  submissionVersion: number,
  token: string
): Promise<void> => {
  const res = await fetch(`${APIURL}/Roles/assessmentVersion/${roleAssessmentMappingId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ submissionVersion }),
  });

  if (!res.ok) {
    throw new Error("Failed to update assessment submission version");
  }
};

export const getAssessmentVersions = async () => {
  try {
    const res = await fetch(`${APIURL}/MasterData/assessment-versions`);
    if (!res.ok) {
      // Endpoint not found or error - use defaults
      return [
        { id: 1, name: "Version 1 - Batch Submission" },
        { id: 2, name: "Version 2 - Sequential Submission" },
      ];
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Network error - use defaults silently
    return [
      { id: 1, name: "Version 1 - Batch Submission" },
      { id: 2, name: "Version 2 - Sequential Submission" },
    ];
  }
};
